import { useEffect, useState } from 'react'

const OtpRemainingExpire = ({ setOtpExpire, startTimeRemaining = 300 }) => {
    const [timeRemaining, setTimeRemaining] = useState(startTimeRemaining);
    const [intervalId, setIntervalId] = useState(null);

    useEffect(() => {
        if (timeRemaining > 0 && !intervalId) {
            const id = setInterval(() => {
                setTimeRemaining(prevTimeRemaining => prevTimeRemaining - 1);
            }, 1000);
            setIntervalId(id);
        } else if (timeRemaining <= 0 && intervalId) {
            clearInterval(intervalId);
            setIntervalId(null);
        }
        if (timeRemaining === 0) {
            setOtpExpire(true);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [timeRemaining, intervalId, startTimeRemaining]);
}

export default OtpRemainingExpire